import React, { useRef, useState, useEffect } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import UserNavbar from "../UserNavbar";
import UserFooter from "../UserFooter";
import MainSidebar from "../Mainsidebar";
import visaImage from "../../Images/visa.png";
import mastercardImage from "../../Images/mastercard.png";
import paypalImage from "../../Images/paypal2.png";
import americanexpressImage from "../../Images/american-express.png";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import "../../Style/CreateInvoice.css";
import "../../Style/Print.css";
import "@fortawesome/fontawesome-free/css/all.css";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toWords } from "number-to-words";
import { path_url } from "../../Config/config";
import axios from "axios";
import ESign from "../../Utils/ESign";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { FaBuilding } from "react-icons/fa";

const DEFAULT_PRODUCT_OPTIONS = [
  { value: "sample-1", label: "Apple", hsnCode: "0808", uom: "KG", rate: 120, discount: 0, cgst: 2.5, sgst: 2.5, igst: 0 },
  { value: "sample-2", label: "Laptop", hsnCode: "8471", uom: "PCS", rate: 50000, discount: 5, cgst: 9, sgst: 9, igst: 0 },
  { value: "sample-3", label: "Software Service", hsnCode: "9983", uom: "HRS", rate: 1000, discount: 0, cgst: 9, sgst: 9, igst: 0 },
  { value: "sample-4", label: "Office Chair", hsnCode: "9401", uom: "PCS", rate: 3500, discount: 10, cgst: 9, sgst: 9, igst: 0 },
  { value: "sample-5", label: "Stationery / Paper", hsnCode: "4802", uom: "BRL", rate: 250, discount: 5, cgst: 6, sgst: 6, igst: 0 },
];

const isValidUUID = (str) => {
  if (!str || typeof str !== "string") return false;
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(str.trim());
};

const CreateInvoice = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const customerData = location.state?.customerData;
  const [hamburger, sethamburger] = useState(false);
  const [isRightMenu, setisRightMenu] = useState(false);
  const [isSearchShow, setIsSearchShow] = useState(false);
  const [fullScreen, setFullScreen] = useState(true);
  const [isSaving, setIsSaving] = useState(false);

  const handleScreenEnter = () => {
    setFullScreen(false);
    document.body.requestFullscreen();
  };

  const handleScreenExit = () => {
    setFullScreen(true);
    document.exitFullscreen();
  };

  const handelShow = () => setIsSearchShow(!isSearchShow);
  const handelRightMenuShow = () => setisRightMenu(!isRightMenu);

  const handleclickonbutton = (hamburgerState) => {
    if (document.documentElement.clientWidth <= 800)
      return { width: "100%", left: "0rem" };
    else
      return {
        width: !hamburgerState && "-webkit-fill-available",
        left: !hamburgerState && "3.7rem",
      };
  };

  const handleclickonbutton1 = (hamburgerState) => {
    if (document.documentElement.clientWidth <= 800) {
      return { display: hamburgerState && "none" };
    }
  };

  const columnNames = [
    "S. No.",
    "Product Description",
    "HSN code",
    "UOM",
    "Qty",
    "Rate",
    "Amount",
    "Discount",
    "Taxable Value",
    "CGST Rate",
    "CGST Amount",
    "SGST Rate",
    "SGST Amount",
    "IGST Rate",
    "IGST Amount",
    "Total",
  ];

  const initialRow = {
    "S. No.": 1,
    "Product Description": null,
    "HSN code": "",
    UOM: "NOS",
    Qty: 1,
    Rate: 0,
    Amount: 0,
    Discount: 0,
    "Taxable Value": 0,
    "CGST Rate": 0,
    "CGST Amount": 0,
    "SGST Rate": 0,
    "SGST Amount": 0,
    "IGST Rate": 0,
    "IGST Amount": 0,
    Total: 0,
    isSent: false,
  };

  const [rows, setRows] = useState([initialRow]);
  const [totalSubtotal, setTotalSubtotal] = useState(0);
  const [totalGrandtotal, setTotalGrandtotal] = useState(0);
  const [totalTax, setTotalTax] = useState(0);
  const [tax, setTax] = useState({ cgstTax: 0, sgstTax: 0, igstTax: 0 });
  const [amountInWords, setAmountInWords] = useState("");
  const [packingCharges, setPackingCharges] = useState(0);
  const [freight, setFreight] = useState(0);
  const [insurance, setInsurance] = useState(0);
  const [customerId, setCustomerId] = useState("");
  const [customerList, setCustomerList] = useState([]);
  const [data, setData] = useState(null);
  const [lgShow, setLgShow] = useState(false);

  const [senderData, setSenderData] = useState({
    name: "",
    address: "",
    gstin: "",
    state: "",
    code: "",
  });
  const [receiverData, setReceiverData] = useState({
    name: customerData
      ? `${customerData.firstName || ""} ${customerData.lastName || ""}`.trim()
      : "",
    address: customerData
      ? `${customerData.street || ""} ${customerData.city || ""} ${customerData.state || ""}`.trim()
      : "",
    gstin: "",
    state: customerData?.state || "",
    code: "",
  });

  useEffect(() => {
    if (location.state?.vendor) {
      const v = location.state.vendor;
      const vendorName =
        v.vendorName ||
        v.companyName ||
        v.name ||
        `${v.fname || ""} ${v.lname || ""}`.trim();
      const vendorAddress =
        v.address ||
        `${v.street || ""} ${v.city || ""} ${v.state || ""} ${v.pincode || v.pinCode || ""}`.trim();
      setReceiverData({
        name: vendorName,
        address: vendorAddress,
        gstin: v.gstin || v.gstNo || v.gst_no || "",
        state: v.state || "",
        code: v.pincode || v.pinCode || "",
      });
      setCustomerId(location.state.vendorId || v.id || v.customerid || null);
    }
  }, [location.state]);

  const [invoiceDetails, setInvoiceDetails] = useState({
    invoiceNo: "",
    invoiceDate: null,
    reverseCharge: false,
    state: "",
    code: "",
    invoiceNotes: "",
  });
  const [transportData, setTransportData] = useState({
    transportMode: "",
    vehicleNumber: "",
    date: null,
    place: "",
  });
  const [bankDetails, setBankDetails] = useState({
    bankName: "",
    bankAccNo: "",
    bankIFSC: "",
    termsAndConditions: "",
  });
  const [invoiceType, setInvoiceType] = useState({
    value: "original",
    label: "Original",
  });
  const options = [
    { value: "original", label: "Original" },
    { value: "duplicate", label: "Duplicate" },
    { value: "triplicate", label: "Triplicate" },
    { value: "extraOC", label: "Extra OC" },
  ];

  const toValidUUID = (id, fallback = "3fa85f64-5717-4562-b3fc-2c963f66afa6") => {
    return isValidUUID(id) ? id.trim() : fallback;
  };

  // Fetch registered customers
  useEffect(() => {
    const fetchCustomers = async () => {
      const token = localStorage.getItem("accessToken");
      const adminId =
        localStorage.getItem("adminId") || localStorage.getItem("userId");
      const headers = token
        ? { Authorization: `Bearer ${token.replace(/^Bearer\s+/i, "")}` }
        : {};

      try {
        let list = [];
        if (adminId && isValidUUID(adminId)) {
          try {
            const res = await axios.get(`${path_url}/customer/all/${adminId}`, { headers });
            const data = res.data?.body || res.data || [];
            if (Array.isArray(data)) list = data;
          } catch (e) {
            const fbRes = await axios.get(`${path_url}/customer/all`, { headers });
            const fbData = fbRes.data?.body || fbRes.data || [];
            if (Array.isArray(fbData)) list = fbData;
          }
        } else {
          const res = await axios.get(`${path_url}/customer/all`, { headers });
          const data = res.data?.body || res.data || [];
          if (Array.isArray(data)) list = data;
        }

        const opts = list.map((c) => {
          const fullName = [c.firstname, c.lastname].filter(Boolean).join(" ");
          const label = c.companyname
            ? `${c.companyname} (${fullName || c.id})`
            : fullName || c.id;
          return { value: c.id, label: label, details: c };
        });
        setCustomerList(opts);
      } catch (err) {
        console.warn("Could not fetch customer list for invoice:", err);
      }
    };
    fetchCustomers();
  }, []);

  const handleCustomerSelect = (selectedOption) => {
    if (!selectedOption) {
      setCustomerId("");
      return;
    }
    const c = selectedOption.details || {};
    const fullName = [c.firstname, c.lastname].filter(Boolean).join(" ");
    const name = c.companyname || fullName || selectedOption.label || "";
    const billingAddr = [c.billingaddress, c.address, c.city, c.state, c.pincode]
      .filter(Boolean)
      .join(", ");
    const shippingAddr = [c.shippingaddress, c.address, c.city, c.state, c.pincode]
      .filter(Boolean)
      .join(", ");
    const gstin = c.gstin || c.gstNumber || "";
    const state = c.state || "Maharashtra";

    setCustomerId(selectedOption.value || "");
    setSenderData((prev) => ({
      ...prev,
      name: name,
      address: billingAddr || prev.address,
      gstin: gstin || prev.gstin,
      state: state || prev.state,
    }));
    setReceiverData((prev) => ({
      ...prev,
      name: name,
      address: shippingAddr || billingAddr || prev.address,
      gstin: gstin || prev.gstin,
      state: state || prev.state,
    }));
  };

  useEffect(() => {
    try {
      const existingStr =
        localStorage.getItem("created_invoices") ||
        localStorage.getItem("local_invoices");
      const list = existingStr ? JSON.parse(existingStr) : [];
      const nextNum = list.length + 1;
      const defaultInvNo = `INV-${String(nextNum).padStart(3, "0")}`;
      setInvoiceDetails((prev) => ({
        ...prev,
        invoiceNo: prev.invoiceNo || defaultInvNo,
        invoiceDate: prev.invoiceDate || new Date(),
      }));
    } catch {
      setInvoiceDetails((prev) => ({
        ...prev,
        invoiceNo: prev.invoiceNo || "INV-001",
        invoiceDate: prev.invoiceDate || new Date(),
      }));
    }
  }, []);

  const handleESignModal = () => setLgShow(true);
  const handleCloseModal = () => setLgShow(false);

  const handleSenderDataChange = (e) => {
    const { name, value } = e.target;
    setSenderData((prev) => ({ ...prev, [name]: value }));
  };

  const handleReceiverDataChange = (e) => {
    const { name, value } = e.target;
    setReceiverData((prev) => ({ ...prev, [name]: value }));
  };

  const handleInvoiceDetailsChange = (name, value) => {
    setInvoiceDetails((prev) => ({ ...prev, [name]: value }));
  };

  const handleTransportDataChange = (name, value) => {
    setTransportData((prev) => ({ ...prev, [name]: value }));
  };

  const handleBankDetailsChange = (e) => {
    const { name, value } = e.target;
    setBankDetails((prev) => ({ ...prev, [name]: value }));
  };

  const handleInvoiceTypeChange = (selected) => setInvoiceType(selected);

  const getProductOptions = () => {
    let rawList = [];
    if (data) {
      if (Array.isArray(data.body?.productList)) rawList = data.body.productList;
      else if (Array.isArray(data.productList)) rawList = data.productList;
      else if (Array.isArray(data.body)) rawList = data.body;
      else if (Array.isArray(data)) rawList = data;
    }

    if (!rawList || rawList.length === 0) {
      rawList = [
        { id: "P-101", productname: "Enterprise ERP Software Subscription", hsnCode: "8523802", unitMeasure: "NOS", sellingprice: 25000, discountPercentage: 0 },
        { id: "P-102", productname: "Cloud Server Hosting & Maintenance", hsnCode: "8523802", unitMeasure: "NOS", sellingprice: 15000, discountPercentage: 0 },
        { id: "P-103", productname: "Technical Support & Training Package", hsnCode: "998313", unitMeasure: "NOS", sellingprice: 10000, discountPercentage: 0 },
        { id: "P-104", productname: "Custom Module Development", hsnCode: "998314", unitMeasure: "HOURS", sellingprice: 5000, discountPercentage: 0 },
      ];
    }

    return rawList.map((product) => {
      const name =
        product.productname ||
        product.productName ||
        product.name ||
        product.product_name ||
        `Product ${product.id}`;
      const price =
        product.sellingprice ||
        product.sellingPrice ||
        product.unitPrice ||
        product.price ||
        0;
      return {
        value: product.id || product.productId || name,
        label: `${name} (₹${price})`,
        productDetails: product,
      };
    });
  };

  const calculateRow = (row) => {
    const qty = parseFloat(row.Qty) || 0;
    const rate = parseFloat(row.Rate) || 0;
    const amount = Number((qty * rate).toFixed(2));
    const discount = parseFloat(row.Discount) || 0;
    const discountAmount = Number(((amount * discount) / 100).toFixed(2));
    const taxableValue = Number((amount - discountAmount).toFixed(2));

    const cgstRate = parseFloat(row["CGST Rate"]) || 0;
    const sgstRate = parseFloat(row["SGST Rate"]) || 0;
    const igstRate = parseFloat(row["IGST Rate"]) || 0;

    const cgstAmount = Number(((taxableValue * cgstRate) / 100).toFixed(2));
    const sgstAmount = Number(((taxableValue * sgstRate) / 100).toFixed(2));
    const igstAmount = Number(((taxableValue * igstRate) / 100).toFixed(2));

    const rowTotal = Number(
      (taxableValue + cgstAmount + sgstAmount + igstAmount).toFixed(2)
    );

    return {
      ...row,
      Qty: row.Qty !== undefined ? row.Qty : qty,
      Rate: row.Rate !== undefined ? row.Rate : rate,
      Amount: amount,
      Discount: row.Discount !== undefined ? row.Discount : discount,
      "Taxable Value": taxableValue,
      "CGST Rate": row["CGST Rate"] !== undefined ? row["CGST Rate"] : cgstRate,
      "CGST Amount": cgstAmount,
      "SGST Rate": row["SGST Rate"] !== undefined ? row["SGST Rate"] : sgstRate,
      "SGST Amount": sgstAmount,
      "IGST Rate": row["IGST Rate"] !== undefined ? row["IGST Rate"] : igstRate,
      "IGST Amount": igstAmount,
      Total: rowTotal,
      subtotal: rowTotal,
    };
  };

  const recalculateTotals = (
    currentRows,
    currentFreight = freight,
    currentInsurance = insurance,
    currentPacking = packingCharges
  ) => {
    const subtotal = currentRows.reduce(
      (sum, r) => sum + (parseFloat(r["Taxable Value"]) || 0),
      0
    );
    const totalCGST = currentRows.reduce(
      (sum, r) => sum + (parseFloat(r["CGST Amount"]) || 0),
      0
    );
    const totalSGST = currentRows.reduce(
      (sum, r) => sum + (parseFloat(r["SGST Amount"]) || 0),
      0
    );
    const totalIGST = currentRows.reduce(
      (sum, r) => sum + (parseFloat(r["IGST Amount"]) || 0),
      0
    );
    const taxSum = totalCGST + totalSGST + totalIGST;

    const fVal = parseFloat(currentFreight) || 0;
    const iVal = parseFloat(currentInsurance) || 0;
    const pVal = parseFloat(currentPacking) || 0;
    const grandtotal = Number(
      (subtotal + taxSum + fVal + iVal + pVal).toFixed(2)
    );

    setTotalSubtotal(Number(subtotal.toFixed(2)));
    setTax({
      cgstTax: Number(totalCGST.toFixed(2)),
      sgstTax: Number(totalSGST.toFixed(2)),
      igstTax: Number(totalIGST.toFixed(2)),
    });
    setTotalTax(Number(taxSum.toFixed(2)));
    setTotalGrandtotal(grandtotal);

    if (grandtotal === 0) {
      setAmountInWords("ZERO");
    } else {
      try {
        const isNegative = grandtotal < 0;
        const rounded = Math.round(Math.abs(grandtotal));
        const words = toWords(rounded).toUpperCase();
        setAmountInWords(isNegative ? `MINUS ${words}` : words);
      } catch (err) {
        setAmountInWords(String(grandtotal));
      }
    }
  };

  const updateCalculatedSummary = (
    currentRows,
    currentFreight = freight,
    currentInsurance = insurance,
    currentPacking = packingCharges
  ) => {
    let subtotalSum = 0;
    let cgstSum = 0;
    let sgstSum = 0;
    let igstSum = 0;

    currentRows.forEach((r) => {
      const qty = parseFloat(r.Qty) || 0;
      const rate = parseFloat(r.Rate) || 0;
      const amount = qty * rate;

      const rawDiscount = parseFloat(r.Discount) || 0;
      const discountAmt =
        rawDiscount > 100
          ? rawDiscount
          : rawDiscount > 0 && rawDiscount <= 100
            ? (rawDiscount / 100) * amount
            : rawDiscount;

      const taxableVal =
        r["Taxable Value"] !== undefined &&
          !isNaN(parseFloat(r["Taxable Value"]))
          ? parseFloat(r["Taxable Value"])
          : Math.max(0, amount - discountAmt);

      const cgstRate = parseFloat(r["CGST Rate"]) || 0;
      const sgstRate = parseFloat(r["SGST Rate"]) || 0;
      const igstRate = parseFloat(r["IGST Rate"]) || 0;

      const cgstAmt =
        r["CGST Amount"] !== undefined &&
          !isNaN(parseFloat(r["CGST Amount"])) &&
          parseFloat(r["CGST Amount"]) > 0
          ? parseFloat(r["CGST Amount"])
          : (taxableVal * cgstRate) / 100;

      const sgstAmt =
        r["SGST Amount"] !== undefined &&
          !isNaN(parseFloat(r["SGST Amount"])) &&
          parseFloat(r["SGST Amount"]) > 0
          ? parseFloat(r["SGST Amount"])
          : (taxableVal * sgstRate) / 100;

      const igstAmt =
        r["IGST Amount"] !== undefined &&
          !isNaN(parseFloat(r["IGST Amount"])) &&
          parseFloat(r["IGST Amount"]) > 0
          ? parseFloat(r["IGST Amount"])
          : (taxableVal * igstRate) / 100;

      subtotalSum += taxableVal;
      cgstSum += cgstAmt;
      sgstSum += sgstAmt;
      igstSum += igstAmt;
    });

    const totalTaxSum = cgstSum + sgstSum + igstSum;
    const freightVal = parseFloat(currentFreight) || 0;
    const insuranceVal = parseFloat(currentInsurance) || 0;
    const packingVal = parseFloat(currentPacking) || 0;

    const grandTotalVal =
      subtotalSum + totalTaxSum + freightVal + insuranceVal + packingVal;

    setTotalSubtotal(subtotalSum.toFixed(2));
    setTax({
      cgstTax: cgstSum.toFixed(2),
      sgstTax: sgstSum.toFixed(2),
      igstTax: igstSum.toFixed(2),
    });
    setTotalTax(totalTaxSum.toFixed(2));
    setTotalGrandtotal(grandTotalVal.toFixed(2));

    try {
      const integerPart = Math.floor(grandTotalVal || 0);
      if (integerPart <= 0) {
        setAmountInWords("ZERO");
      } else {
        const words = toWords(integerPart);
        setAmountInWords(words.toUpperCase());
      }
    } catch (e) {
      setAmountInWords(`${grandTotalVal.toFixed(2)}`);
    }
  };

  const handlePackingChargesChange = (e) => {
    const val = e.target.value;
    setPackingCharges(val);
    updateCalculatedSummary(rows, freight, insurance, val);
  };

  const handleFreightChange = (e) => {
    const val = e.target.value;
    setFreight(val);
    updateCalculatedSummary(rows, val, insurance, packingCharges);
  };

  const handleInsuranceChange = (e) => {
    const val = e.target.value;
    setInsurance(val);
    updateCalculatedSummary(rows, freight, val, packingCharges);
  };

  const handleInputChange = (index, key, value) => {
    setRows((prevRows) => {
      const newRows = [...prevRows];
      let row = { ...newRows[index] };

      if (key === "Product Description") {
        row["Product Description"] = value;
        if (value) {
          const productId = value.value;
          const label = (value.label || value.value || "").trim();

          const product = data?.body?.productList?.find(
            (item) => item.id === productId || (item.productname && item.productname.toLowerCase() === label.toLowerCase())
          );
          const gstRates = product
            ? data?.body?.gstRateList?.find((item) => item.productid === product.id)
            : null;

          const sample = DEFAULT_PRODUCT_OPTIONS.find(
            (item) => item.value === productId || item.label.toLowerCase() === label.toLowerCase()
          );

          if (product) {
            row["HSN code"] = product.hsnCode || "";
            row["UOM"] = product.unitMeasure || "";
            row["Rate"] = parseFloat(product.sellingprice) || 0;
            row["Discount"] = parseFloat(product.discountPercentage) || 0;
            row["CGST Rate"] = gstRates ? parseFloat(gstRates.cgst) || 0 : 0;
            row["SGST Rate"] = gstRates ? parseFloat(gstRates.sgst) || 0 : 0;
            row["IGST Rate"] = gstRates ? parseFloat(gstRates.igst) || 0 : 0;
          } else if (sample) {
            row["HSN code"] = sample.hsnCode;
            row["UOM"] = sample.uom;
            row["Rate"] = sample.rate;
            row["Discount"] = sample.discount;
            row["CGST Rate"] = sample.cgst;
            row["SGST Rate"] = sample.sgst;
            row["IGST Rate"] = sample.igst;
          }
          row.Qty = (parseFloat(row.Qty) || 0) > 0 ? row.Qty : 1;
        }
        row = calculateRow(row);
        newRows[index] = row;
      } else {
        row[key] = value;
        if (
          ["Qty", "Rate", "Discount", "CGST Rate", "SGST Rate", "IGST Rate"].includes(key)
        ) {
          row = calculateRow(row);
        } else if (key === "Taxable Value") {
          const tv = parseFloat(value) || 0;
          const cgstR = parseFloat(row["CGST Rate"]) || 0;
          const sgstR = parseFloat(row["SGST Rate"]) || 0;
          const igstR = parseFloat(row["IGST Rate"]) || 0;
          row["CGST Amount"] = Number(((tv * cgstR) / 100).toFixed(2));
          row["SGST Amount"] = Number(((tv * sgstR) / 100).toFixed(2));
          row["IGST Amount"] = Number(((tv * igstR) / 100).toFixed(2));
          row.Total = Number(
            (tv + row["CGST Amount"] + row["SGST Amount"] + row["IGST Amount"]).toFixed(2)
          );
          row.subtotal = row.Total;
        } else if (["CGST Amount", "SGST Amount", "IGST Amount"].includes(key)) {
          const tv = parseFloat(row["Taxable Value"]) || 0;
          const cA = parseFloat(key === "CGST Amount" ? value : row["CGST Amount"]) || 0;
          const sA = parseFloat(key === "SGST Amount" ? value : row["SGST Amount"]) || 0;
          const iA = parseFloat(key === "IGST Amount" ? value : row["IGST Amount"]) || 0;
          row.Total = Number((tv + cA + sA + iA).toFixed(2));
          row.subtotal = row.Total;
        }
        newRows[index] = row;
      }

      recalculateTotals(newRows);
      return newRows;
    });
  };

  // ── Print ──────────────────────────────────────────────────
  const handlePrint = () => {
    try {
      const invDateStr = invoiceDetails.invoiceDate
        ? new Date(invoiceDetails.invoiceDate).toLocaleDateString("en-IN")
        : "N/A";
      const transDateStr = transportData.date
        ? new Date(transportData.date).toLocaleDateString("en-IN")
        : "N/A";

      const freightVal = parseFloat(freight) || 0;
      const insuranceVal = parseFloat(insurance) || 0;
      const packingVal = parseFloat(packingCharges) || 0;

      const rowsHtml = rows
        .map((r, i) => {
          const desc =
            typeof r["Product Description"] === "object"
              ? r["Product Description"]?.label || ""
              : r["Product Description"] || "";
          const rate = parseFloat(r.Rate) || 0;
          const disc = parseFloat(r.Discount) || 0;
          const taxable = parseFloat(r["Taxable Value"]) || 0;

          const cgstAmt =
            r["CGST Amount"] !== undefined && !isNaN(parseFloat(r["CGST Amount"]))
              ? parseFloat(r["CGST Amount"])
              : r.CGST?.Amount !== undefined
                ? parseFloat(r.CGST.Amount)
                : (taxable * (parseFloat(r["CGST Rate"]) || 0)) / 100;

          const sgstAmt =
            r["SGST Amount"] !== undefined && !isNaN(parseFloat(r["SGST Amount"]))
              ? parseFloat(r["SGST Amount"])
              : r.SGST?.Amount !== undefined
                ? parseFloat(r.SGST.Amount)
                : (taxable * (parseFloat(r["SGST Rate"]) || 0)) / 100;

          const igstAmt =
            r["IGST Amount"] !== undefined && !isNaN(parseFloat(r["IGST Amount"]))
              ? parseFloat(r["IGST Amount"])
              : r.IGST?.Amount !== undefined
                ? parseFloat(r.IGST.Amount)
                : (taxable * (parseFloat(r["IGST Rate"]) || 0)) / 100;

          const total = parseFloat(r.Total) || 0;

          return `
            <tr>
              <td style="text-align: center;">${i + 1}</td>
              <td><strong>${desc || "-"}</strong></td>
              <td style="text-align: center;">${r["HSN code"] || "-"}</td>
              <td style="text-align: center;">${r.UOM || "NOS"}</td>
              <td style="text-align: center; font-weight: 600;">${r.Qty || 1}</td>
              <td style="text-align: right;">Rs. ${rate.toFixed(2)}</td>
              <td style="text-align: right;">${disc > 0 ? "Rs. " + disc.toFixed(2) : "-"}</td>
              <td style="text-align: right; font-weight: 600;">Rs. ${taxable.toFixed(2)}</td>
              <td style="text-align: right;">${cgstAmt > 0 ? "Rs. " + cgstAmt.toFixed(2) : "-"}</td>
              <td style="text-align: right;">${sgstAmt > 0 ? "Rs. " + sgstAmt.toFixed(2) : "-"}</td>
              <td style="text-align: right;">${igstAmt > 0 ? "Rs. " + igstAmt.toFixed(2) : "-"}</td>
              <td style="text-align: right; font-weight: 700;">Rs. ${total.toFixed(2)}</td>
            </tr>
          `;
        })
        .join("");

      const printHtml = `
        <!DOCTYPE html>
        <html>
        <head>
          <title>Tax Invoice - ${invoiceDetails.invoiceNo || "Draft"}</title>
          <meta charset="utf-8" />
          <style>
            @page { size: A4 portrait; margin: 10mm; }
            * { box-sizing: border-box; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif; }
            body { margin: 0; padding: 0; color: #1e293b; font-size: 12px; line-height: 1.4; background: #fff; }
            .invoice-container { width: 100%; max-width: 800px; margin: 0 auto; border: 1px solid #cbd5e1; padding: 20px; }
            .header-top { display: flex; justify-content: space-between; align-items: flex-start; border-bottom: 2px solid #0f172a; padding-bottom: 12px; margin-bottom: 14px; }
            .title-area h1 { margin: 0; font-size: 22px; font-weight: 800; color: #0f172a; letter-spacing: -0.02em; }
            .title-area span { font-size: 11px; color: #64748b; font-weight: 600; text-transform: uppercase; }
            .meta-grid { text-align: right; font-size: 11px; }
            .meta-grid div { margin-bottom: 3px; }
            .meta-grid strong { color: #0f172a; }
            .info-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin-bottom: 16px; }
            .info-card { background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 4px; padding: 10px 12px; }
            .info-card-title { font-size: 10px; font-weight: 700; color: #0d9488; text-transform: uppercase; letter-spacing: 0.05em; margin-bottom: 6px; border-bottom: 1px solid #e2e8f0; padding-bottom: 4px; }
            .info-card-name { font-size: 12px; font-weight: 700; color: #0f172a; margin-bottom: 4px; }
            .info-card p { margin: 2px 0; color: #475569; font-size: 11px; }
            table.items-table { width: 100%; border-collapse: collapse; margin-bottom: 16px; font-size: 11px; }
            table.items-table th { background: #0f172a; color: #ffffff; font-weight: 700; font-size: 10px; padding: 7px 5px; border: 1px solid #0f172a; text-transform: uppercase; letter-spacing: 0.03em; }
            table.items-table td { border: 1px solid #cbd5e1; padding: 6px 5px; vertical-align: middle; }
            table.items-table tbody tr:nth-child(even) { background-color: #f8fafc; }
            .summary-section { display: grid; grid-template-columns: 1.2fr 1fr; gap: 16px; margin-bottom: 16px; page-break-inside: avoid; }
            .words-box { background: #f8fafc; border: 1px solid #e2e8f0; border-left: 3px solid #0d9488; border-radius: 4px; padding: 10px; margin-bottom: 10px; }
            .words-title { font-size: 9px; font-weight: 700; color: #64748b; text-transform: uppercase; margin-bottom: 2px; }
            .words-val { font-size: 11px; font-weight: 700; color: #0f172a; font-style: italic; }
            .bank-box { background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 4px; padding: 10px; font-size: 10.5px; }
            .bank-title { font-size: 10px; font-weight: 700; color: #0f172a; text-transform: uppercase; margin-bottom: 4px; border-bottom: 1px solid #e2e8f0; padding-bottom: 3px; }
            .summary-table { width: 100%; border-collapse: collapse; font-size: 11px; }
            .summary-table td { padding: 4px 6px; border-bottom: 1px solid #e2e8f0; }
            .summary-table td:last-child { text-align: right; font-weight: 600; }
            .grand-total-row { background: #f0fdfa; font-size: 13px; font-weight: 800; color: #0f766e; border-top: 2px solid #0f766e !important; }
            .footer-sign { display: flex; justify-content: space-between; align-items: flex-end; margin-top: 20px; padding-top: 10px; border-top: 1px dashed #cbd5e1; page-break-inside: avoid; }
            .terms-notes { max-width: 60%; font-size: 9.5px; color: #64748b; line-height: 1.4; }
            .signature-area { text-align: center; font-size: 11px; }
            .signature-line { width: 160px; border-top: 1px solid #0f172a; margin-top: 35px; margin-bottom: 4px; }
            @media print { body { background: #fff; } .invoice-container { border: none; padding: 0; max-width: 100%; } }
          </style>
        </head>
        <body>
          <div class="invoice-container">
            <div class="header-top">
              <div class="title-area">
                <h1>TAX INVOICE</h1>
                <span>${invoiceType?.label || "Original"} Copy</span>
              </div>
              <div class="meta-grid">
                <div><strong>Invoice No:</strong> ${invoiceDetails.invoiceNo || "N/A"}</div>
                <div><strong>Invoice Date:</strong> ${invDateStr}</div>
                <div><strong>Place of Supply:</strong> ${invoiceDetails.state || "N/A"}</div>
                <div><strong>Reverse Charge:</strong> ${invoiceDetails.reverseCharge ? "Yes" : "No"}</div>
              </div>
            </div>

            <div class="info-grid">
              <div class="info-card">
                <div class="info-card-title">Billed By (Supplier)</div>
                <div class="info-card-name">${senderData.name || "Entelipro ERP Ltd."}</div>
                <p>${senderData.address || ""}</p>
                <p><strong>GSTIN:</strong> ${senderData.gstin || "N/A"}</p>
                <p><strong>State:</strong> ${senderData.state || "N/A"} ${senderData.code ? `(${senderData.code})` : ""}</p>
              </div>

              <div class="info-card">
                <div class="info-card-title">Billed To (Customer)</div>
                <div class="info-card-name">${receiverData.name || "N/A"}</div>
                <p>${receiverData.address || ""}</p>
                <p><strong>GSTIN:</strong> ${receiverData.gstin || "N/A"}</p>
                <p><strong>State:</strong> ${receiverData.state || "N/A"} ${receiverData.code ? `(${receiverData.code})` : ""}</p>
              </div>
            </div>

            ${transportData.transportMode || transportData.vehicleNumber
          ? `
              <div class="info-card" style="margin-bottom: 14px;">
                <div class="info-card-title">Transport & Dispatch Details</div>
                <div style="display: flex; gap: 20px; font-size: 11px; flex-wrap: wrap;">
                  <div><strong>Mode:</strong> ${transportData.transportMode || "N/A"}</div>
                  <div><strong>Vehicle No:</strong> ${transportData.vehicleNumber || "N/A"}</div>
                  <div><strong>Date:</strong> ${transDateStr}</div>
                  <div><strong>Destination:</strong> ${transportData.place || "N/A"}</div>
                </div>
              </div>
            `
          : ""
        }

            <table class="items-table">
              <thead>
                <tr>
                  <th style="width: 35px; text-align: center;">S.N</th>
                  <th>Product Description</th>
                  <th style="width: 65px; text-align: center;">HSN</th>
                  <th style="width: 45px; text-align: center;">UOM</th>
                  <th style="width: 45px; text-align: center;">Qty</th>
                  <th style="width: 65px; text-align: right;">Rate</th>
                  <th style="width: 55px; text-align: right;">Disc</th>
                  <th style="width: 70px; text-align: right;">Taxable</th>
                  <th style="width: 60px; text-align: right;">CGST</th>
                  <th style="width: 60px; text-align: right;">SGST</th>
                  <th style="width: 60px; text-align: right;">IGST</th>
                  <th style="width: 75px; text-align: right;">Total</th>
                </tr>
              </thead>
              <tbody>
                ${rowsHtml}
              </tbody>
            </table>

            <div class="summary-section">
              <div>
                <div class="words-box">
                  <div class="words-title">Total Amount in Words</div>
                  <div class="words-val">Rs. ${amountInWords || "Zero Rupees Only"}</div>
                </div>

                <div class="bank-box">
                  <div class="bank-title">Bank & Payment Details</div>
                  <div><strong>Bank Name:</strong> ${bankDetails.bankName || "HDFC Bank Ltd"}</div>
                  <div><strong>Account Number:</strong> ${bankDetails.bankAccNo || "N/A"}</div>
                  <div><strong>IFSC Code:</strong> ${bankDetails.bankIFSC || "N/A"}</div>
                </div>
              </div>

              <div>
                <table class="summary-table">
                  <tbody>
                    <tr><td>Total Amount before Tax:</td><td>Rs. ${totalSubtotal || 0}</td></tr>
                    <tr><td>Total CGST Amount:</td><td>Rs. ${tax.cgstTax || 0}</td></tr>
                    <tr><td>Total SGST Amount:</td><td>Rs. ${tax.sgstTax || 0}</td></tr>
                    <tr><td>Total IGST Amount:</td><td>Rs. ${tax.igstTax || 0}</td></tr>
                    <tr><td>Total Tax Amount:</td><td>Rs. ${totalTax || 0}</td></tr>
                    <tr><td>Freight:</td><td>Rs. ${freightVal.toFixed(2)}</td></tr>
                    <tr><td>Insurance:</td><td>Rs. ${insuranceVal.toFixed(2)}</td></tr>
                    <tr><td>Packing & Forwarding:</td><td>Rs. ${packingVal.toFixed(2)}</td></tr>
                    <tr class="grand-total-row">
                      <td><strong>Grand Total:</strong></td>
                      <td><strong>Rs. ${totalGrandtotal || 0}</strong></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="footer-sign">
              <div class="terms-notes">
                <strong>Terms & Conditions / Payment Notes:</strong><br />
                ${(bankDetails.termsAndConditions || "Payment due within specified credit terms. Goods once sold will not be taken back.").replace(/\n/g, "<br />")}
              </div>
              <div class="signature-area">
                <div class="signature-line"></div>
                <strong>Authorized Signatory</strong>
              </div>
            </div>
          </div>
        </body>
        </html>
      `;

      const printWindow = window.open("", "_blank");
      if (printWindow) {
        printWindow.document.open();
        printWindow.document.write(printHtml);
        printWindow.document.close();
        printWindow.focus();
        setTimeout(() => printWindow.print(), 300);
      } else {
        toast.error("Pop-up blocked. Please allow pop-ups to print the invoice.");
      }
    } catch (err) {
      console.error("Print Invoice error:", err);
      toast.error("Failed to print invoice. Please try again.");
    }
  };

  // ── PDF generation ─────────────────────────────────────────
  const handleGeneratePDF = () => {
    try {
      if (!rows || rows.length === 0) {
        toast.warn("Please add at least one product item before generating PDF.");
        return;
      }

      const doc = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
      });

      const runAutoTable = (options) => {
        if (typeof autoTable === "function") {
          autoTable(doc, options);
        } else if (typeof doc.autoTable === "function") {
          doc.autoTable(options);
        } else {
          throw new Error("jsPDF autoTable plugin is not available.");
        }
      };

      const primaryColor = [13, 148, 136];
      const darkColor = [30, 41, 59];
      const lightGray = [241, 245, 249];
      const grayText = [100, 116, 139];
      const pageWidth = doc.internal.pageSize.getWidth();

      doc.setFont("helvetica", "bold");
      doc.setFontSize(20);
      doc.setTextColor(...darkColor);
      doc.text("TAX INVOICE", 14, 20);

      doc.setFontSize(9);
      doc.setFont("helvetica", "normal");
      doc.setTextColor(...grayText);
      doc.text(invoiceType?.label ? `(${invoiceType.label} Copy)` : "", 14, 25);

      doc.setFontSize(9);
      doc.setTextColor(...darkColor);
      doc.setFont("helvetica", "bold");
      doc.text("Invoice No:", pageWidth - 70, 18);
      doc.setFont("helvetica", "normal");
      doc.text(`${invoiceDetails.invoiceNo || "N/A"}`, pageWidth - 45, 18);

      const invDateStr = invoiceDetails.invoiceDate
        ? new Date(invoiceDetails.invoiceDate).toLocaleDateString("en-IN")
        : "N/A";
      doc.setFont("helvetica", "bold");
      doc.text("Invoice Date:", pageWidth - 70, 23);
      doc.setFont("helvetica", "normal");
      doc.text(`${invDateStr}`, pageWidth - 45, 23);

      doc.setFont("helvetica", "bold");
      doc.text("Place of Supply:", pageWidth - 70, 28);
      doc.setFont("helvetica", "normal");
      doc.text(`${invoiceDetails.state || "N/A"}`, pageWidth - 45, 28);

      doc.setDrawColor(226, 232, 240);
      doc.setLineWidth(0.5);
      doc.line(14, 33, pageWidth - 14, 33);

      // Billed By
      doc.setFillColor(...lightGray);
      doc.rect(14, 37, (pageWidth - 32) / 2, 38, "F");
      doc.setFont("helvetica", "bold");
      doc.setFontSize(9.5);
      doc.setTextColor(...primaryColor);
      doc.text("BILLED BY (SUPPLIER)", 18, 43);

      doc.setFont("helvetica", "bold");
      doc.setFontSize(9);
      doc.setTextColor(...darkColor);
      doc.text(`${senderData.name || "N/A"}`, 18, 49);

      doc.setFont("helvetica", "normal");
      doc.setFontSize(8.5);
      doc.setTextColor(...grayText);
      const senderAddressLines = doc.splitTextToSize(
        `${senderData.address || "N/A"}`,
        (pageWidth - 48) / 2
      );
      doc.text(senderAddressLines, 18, 54);

      const senderGstY = Math.min(68, 54 + (senderAddressLines.length || 1) * 4);
      doc.setFont("helvetica", "bold");
      doc.setTextColor(...darkColor);
      doc.text(`GSTIN: ${senderData.gstin || "N/A"}`, 18, senderGstY);
      doc.text(
        `State: ${senderData.state || "N/A"} (${senderData.code || ""})`,
        18,
        senderGstY + 4
      );

      // Billed To
      const rightX = 14 + (pageWidth - 32) / 2 + 4;
      doc.setFillColor(...lightGray);
      doc.rect(rightX, 37, (pageWidth - 32) / 2, 38, "F");
      doc.setFont("helvetica", "bold");
      doc.setFontSize(9.5);
      doc.setTextColor(...primaryColor);
      doc.text("BILLED TO (CUSTOMER)", rightX + 4, 43);

      doc.setFont("helvetica", "bold");
      doc.setFontSize(9);
      doc.setTextColor(...darkColor);
      doc.text(`${receiverData.name || "N/A"}`, rightX + 4, 49);

      doc.setFont("helvetica", "normal");
      doc.setFontSize(8.5);
      doc.setTextColor(...grayText);
      const receiverAddressLines = doc.splitTextToSize(
        `${receiverData.address || "N/A"}`,
        (pageWidth - 48) / 2
      );
      doc.text(receiverAddressLines, rightX + 4, 54);

      const receiverGstY = Math.min(68, 54 + (receiverAddressLines.length || 1) * 4);
      doc.setFont("helvetica", "bold");
      doc.setTextColor(...darkColor);
      doc.text(`GSTIN: ${receiverData.gstin || "N/A"}`, rightX + 4, receiverGstY);
      doc.text(
        `State: ${receiverData.state || "N/A"} (${receiverData.code || ""})`,
        rightX + 4,
        receiverGstY + 4
      );

      const tableHead = [
        [
          { content: "S.N", styles: { halign: "center" } },
          { content: "Product Description", styles: { halign: "left" } },
          { content: "HSN", styles: { halign: "center" } },
          { content: "Qty", styles: { halign: "center" } },
          { content: "Rate", styles: { halign: "right" } },
          { content: "Disc", styles: { halign: "right" } },
          { content: "Taxable", styles: { halign: "right" } },
          { content: "CGST", styles: { halign: "right" } },
          { content: "SGST", styles: { halign: "right" } },
          { content: "IGST", styles: { halign: "right" } },
          { content: "Total", styles: { halign: "right" } },
        ],
      ];

      const tableRows = rows.map((r, i) => {
        const desc =
          typeof r["Product Description"] === "object"
            ? r["Product Description"]?.label || ""
            : r["Product Description"] || "";
        const rate = parseFloat(r.Rate) || 0;
        const disc = parseFloat(r.Discount) || 0;
        const taxable = parseFloat(r["Taxable Value"]) || 0;

        const cgstAmt =
          r["CGST Amount"] !== undefined && !isNaN(parseFloat(r["CGST Amount"]))
            ? parseFloat(r["CGST Amount"])
            : r.CGST?.Amount !== undefined
              ? parseFloat(r.CGST.Amount)
              : (taxable * (parseFloat(r["CGST Rate"]) || 0)) / 100;

        const sgstAmt =
          r["SGST Amount"] !== undefined && !isNaN(parseFloat(r["SGST Amount"]))
            ? parseFloat(r["SGST Amount"])
            : r.SGST?.Amount !== undefined
              ? parseFloat(r.SGST.Amount)
              : (taxable * (parseFloat(r["SGST Rate"]) || 0)) / 100;

        const igstAmt =
          r["IGST Amount"] !== undefined && !isNaN(parseFloat(r["IGST Amount"]))
            ? parseFloat(r["IGST Amount"])
            : r.IGST?.Amount !== undefined
              ? parseFloat(r.IGST.Amount)
              : (taxable * (parseFloat(r["IGST Rate"]) || 0)) / 100;

        const total = parseFloat(r.Total) || 0;

        return [
          i + 1,
          desc,
          r["HSN code"] || "N/A",
          `${r.Qty || 1} ${r.UOM || ""}`.trim(),
          `Rs. ${rate.toFixed(2)}`,
          disc > 0 ? `Rs. ${disc.toFixed(2)}` : "-",
          `Rs. ${taxable.toFixed(2)}`,
          cgstAmt > 0 ? `Rs. ${cgstAmt.toFixed(2)}` : "-",
          sgstAmt > 0 ? `Rs. ${sgstAmt.toFixed(2)}` : "-",
          igstAmt > 0 ? `Rs. ${igstAmt.toFixed(2)}` : "-",
          `Rs. ${total.toFixed(2)}`,
        ];
      });

      runAutoTable({
        head: tableHead,
        body: tableRows,
        startY: 80,
        theme: "grid",
        styles: { fontSize: 8, cellPadding: 2.5, font: "helvetica" },
        headStyles: {
          fillColor: [15, 23, 42],
          textColor: [255, 255, 255],
          fontStyle: "bold",
          fontSize: 7.5,
        },
        alternateRowStyles: { fillColor: [248, 250, 252] },
        margin: { left: 14, right: 14 },
      });

      let finalY =
        doc.lastAutoTable && doc.lastAutoTable.finalY
          ? doc.lastAutoTable.finalY + 6
          : 140;

      if (finalY > 210) {
        doc.addPage();
        finalY = 20;
      }

      const freightVal = parseFloat(freight) || 0;
      const insuranceVal = parseFloat(insurance) || 0;
      const packingVal = parseFloat(packingCharges) || 0;

      const summaryTableData = [
        ["Total Amount before Tax:", `Rs. ${totalSubtotal || 0}`],
        ["Total CGST Amount:", `Rs. ${tax.cgstTax || 0}`],
        ["Total SGST Amount:", `Rs. ${tax.sgstTax || 0}`],
        ["Total IGST Amount:", `Rs. ${tax.igstTax || 0}`],
        ["Total Tax Amount:", `Rs. ${totalTax || 0}`],
        ["Freight Charges:", `Rs. ${freightVal.toFixed(2)}`],
        ["Insurance Charges:", `Rs. ${insuranceVal.toFixed(2)}`],
        ["Packing & Forwarding:", `Rs. ${packingVal.toFixed(2)}`],
        ["Grand Total:", `Rs. ${totalGrandtotal || 0}`],
      ];

      runAutoTable({
        body: summaryTableData,
        startY: finalY,
        theme: "plain",
        styles: { fontSize: 8.5, cellPadding: 1.5, font: "helvetica" },
        columnStyles: {
          0: { cellWidth: 50, fontStyle: "normal", textColor: grayText },
          1: { cellWidth: 35, fontStyle: "bold", halign: "right", textColor: darkColor },
        },
        margin: { left: pageWidth - 100, right: 14 },
      });

      doc.setFont("helvetica", "bold");
      doc.setFontSize(8.5);
      doc.setTextColor(...darkColor);
      doc.text("Amount in Words:", 14, finalY + 4);

      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);
      doc.setTextColor(...grayText);
      const wordsLines = doc.splitTextToSize(
        `${amountInWords || "Zero Rupees Only"}`,
        pageWidth - 120
      );
      doc.text(wordsLines, 14, finalY + 9);

      const bankY = finalY + 16 + (wordsLines.length - 1) * 4;
      doc.setFont("helvetica", "bold");
      doc.setFontSize(8.5);
      doc.setTextColor(...darkColor);
      doc.text("Bank & Payment Details:", 14, bankY);

      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);
      doc.setTextColor(...grayText);
      doc.text(`Bank Name: ${bankDetails.bankName || "N/A"}`, 14, bankY + 4.5);
      doc.text(`Account No: ${bankDetails.bankAccNo || "N/A"}`, 14, bankY + 8.5);
      doc.text(`IFSC Code: ${bankDetails.bankIFSC || "N/A"}`, 14, bankY + 12.5);

      if (bankDetails.termsAndConditions) {
        doc.text(`Terms: ${bankDetails.termsAndConditions}`, 14, bankY + 16.5, {
          maxWidth: pageWidth - 120,
        });
      }

      const fileName = `Invoice_${invoiceDetails.invoiceNo || "Draft"}.pdf`;
      doc.save(fileName);

      toast.success("Invoice PDF generated and downloaded successfully!", {
        position: "top-right",
        autoClose: 3000,
      });
    } catch (err) {
      console.error("Generate PDF error:", err);
      toast.error(
        `Failed to generate PDF: ${err.message || "Please check invoice details."}`
      );
    }
  };

  const handleDeleteRow = (index) => {
    setRows((prevRows) => {
      const updatedRows = prevRows.filter((_, i) => i !== index);
      recalculateTotals(updatedRows);
      return updatedRows;
    });
    toast.success("Product removed", {
      position: "top-right",
      autoClose: 2000,
    });
  };

  const handleCalculation = () => {
    setRows((prevRows) => {
      const updatedRows = prevRows.map((r) => calculateRow(r));
      recalculateTotals(updatedRows);
      return updatedRows;
    });
    toast.success("Taxes and invoice totals calculated successfully!");
  };

  const createCustomerWithAddress = async (token, usercid, adminId) => {
    try {
      const customerName = receiverData.name || senderData.name || "Invoice Customer";
      const nameParts = customerName.trim().split(" ");
      const firstName = nameParts[0] || "Customer";
      const lastName = nameParts.slice(1).join(" ") || "Account";

      const customerPayload = {
        customer: {
          readstatus: "OPEN",
          companyname: customerName,
          firstname: firstName,
          lastname: lastName,
          leadsource: "INVOICE",
          status: "OPEN",
          mobile: "9876543210",
          email: `${firstName.toLowerCase().replace(/[^a-z0-9]/g, "")}@invoice.com`,
          usercid: usercid || adminId,
          useradminid: adminId,
          owner: adminId,
        },
        billingAddress: {
          active: true,
          name: "Billing Address",
          state: receiverData.state || senderData.state || "Madhya Pradesh",
          country: "India",
          address1: receiverData.address || senderData.address || "25, Vijay Nagar, Indore",
          address2: "",
          pincode: receiverData.code || senderData.code || "452010",
          city: (receiverData.address || senderData.address || "Indore").split(",")[0].trim() || "Indore",
        },
        shippingAddress: {
          active: true,
          name: "Shipping Address",
          state: senderData.state || receiverData.state || "Madhya Pradesh",
          country: "India",
          address1: senderData.address || receiverData.address || "25, Vijay Nagar, Indore",
          address2: "",
          pincode: senderData.code || receiverData.code || "452010",
          city: (senderData.address || receiverData.address || "Indore").split(",")[0].trim() || "Indore",
        },
      };

      const custRes = await axios.post(`${path_url}/customer`, customerPayload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const createdCustId =
        custRes.data?.body?.customer?.id ||
        custRes.data?.body?.id ||
        custRes.data?.id ||
        custRes.data?.customer?.id;

      return createdCustId || null;
    } catch (err) {
      console.error("Error creating customer with address:", err);
      return null;
    }
  };

  const formatDateForBackend = (dateVal) => {
    if (!dateVal) return new Date().toISOString().split("T")[0];
    if (dateVal instanceof Date) {
      const year = dateVal.getFullYear();
      const month = String(dateVal.getMonth() + 1).padStart(2, "0");
      const day = String(dateVal.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    }
    if (typeof dateVal === "string") {
      return dateVal.split("T")[0];
    }
    return new Date().toISOString().split("T")[0];
  };

  const handleSaveInvoice = async () => {
    const token = localStorage.getItem("accessToken");
    const usercid =
      localStorage.getItem("userId") ||
      localStorage.getItem("adminId") ||
      localStorage.getItem("usercid");
    const adminId = localStorage.getItem("adminId");

    if (!token) {
      toast.error("You are not logged in. Please login first.");
      return;
    }

    setIsSaving(true);
    try {
      let targetCustomerId = customerId;

      if (!targetCustomerId) {
        targetCustomerId = await createCustomerWithAddress(token, usercid, adminId);
        if (targetCustomerId) {
          setCustomerId(targetCustomerId);
        } else if (customerList && customerList.length > 0) {
          targetCustomerId = customerList[0].value;
        }
      }

      if (!targetCustomerId) {
        toast.error(
          "Could not create or associate customer for invoice. Please enter consignee/receiver details."
        );
        return;
      }

      const formattedInvoiceDate = formatDateForBackend(invoiceDetails.invoiceDate);
      const formattedTransportDate = formatDateForBackend(transportData.date);

      const payload = {
        status: "New",
        customerid: targetCustomerId,
        usercid: usercid,
        useradminid: adminId,
        subject: invoiceDetails.invoiceNo
          ? `Invoice - ${invoiceDetails.invoiceNo}`
          : "Invoice",
        invoiceNo: invoiceDetails.invoiceNo || `INV-${Date.now().toString().slice(-4)}`,
        invoiceDate: formattedInvoiceDate,
        reverseCharge: invoiceDetails.reverseCharge?.value || "No",
        place: transportData.place || "",
        transportMode: transportData.transportMode || "",
        vehicleNumber: transportData.vehicleNumber || "",
        transportDate: formattedTransportDate,
        receiverName: senderData.name || "",
        receiverAddress: senderData.address || "",
        receiverGstin: senderData.gstin || "",
        receiverState: senderData.state || "",
        receiverCode: senderData.code || "",
        consigneeName: receiverData.name || "",
        consigneeAddress: receiverData.address || "",
        consigneeGstin: receiverData.gstin || "",
        consigneeState: receiverData.state || "",
        consigneeCode: receiverData.code || "",
        bankName: bankDetails.bankName || "",
        bankAccNo: bankDetails.bankAccNo || "",
        bankIFSC: bankDetails.bankIFSC || "",
        termsAndConditions: bankDetails.termsAndConditions || "",
        totalSubtotal: totalSubtotal || 0,
        totalCGST: tax.cgstTax || 0,
        totalSGST: tax.sgstTax || 0,
        totalIGST: tax.igstTax || 0,
        totalTax: totalTax || 0,
        freight: parseFloat(freight) || 0,
        insurance: parseFloat(insurance) || 0,
        packingCharges: parseFloat(packingCharges) || 0,
        grandTotal: totalGrandtotal || 0,
        amountInWords: amountInWords || "",
      };

      console.group("🚀 [API CALL] Starting Invoice Save Process");
      console.log("Invoice Payload to be sent:", payload);

      try {
        console.log(`📡 [API CALL] POST ${path_url}/invoice`);
        const response = await axios.post(`${path_url}/invoice`, payload, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        console.log("✅ [API RESPONSE] Invoice saved successfully:", response.status, response.data);
        console.groupEnd();
        toast.success("Invoice saved successfully to database!");
      } catch (firstErr) {
        console.warn(
          "⚠️ [API ERROR] First POST /invoice attempt failed:",
          firstErr?.response?.status,
          firstErr?.response?.data || firstErr.message
        );

        const errMsg = (
          firstErr?.response?.data?.message ||
          firstErr?.response?.data?.error ||
          (typeof firstErr?.response?.data === "string" ? firstErr.response.data : "") ||
          firstErr?.message ||
          ""
        ).toLowerCase();

        if (errMsg.includes("address") || errMsg.includes("customer")) {
          console.log(
            "🔧 Customer address issue encountered. Creating customer with full address..."
          );
          const newCustId = await createCustomerWithAddress(token, usercid, adminId);
          if (newCustId) {
            payload.customerid = newCustId;
            setCustomerId(newCustId);
            console.log(
              `📡 [API CALL] Retrying POST ${path_url}/invoice with customer ID: ${newCustId}`
            );
            const retryRes = await axios.post(`${path_url}/invoice`, payload, {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            });
            console.log("✅ [API RESPONSE] Invoice saved retry response:", retryRes.status, retryRes.data);
            console.groupEnd();
            toast.success("Invoice saved successfully to database!");
            return;
          }
        }
        console.groupEnd();
        throw firstErr;
      }
    } catch (error) {
      console.error("❌ [API ERROR] Error saving invoice:", error);
      const errorMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        (typeof error?.response?.data === "string" ? error.response.data : null) ||
        error?.message ||
        "Failed to save invoice to backend. Please check your backend connection.";
      toast.error(errorMessage);
    } finally {
      setIsSaving(false);
    }
  };

  const handleSendRow = (index) => {
    handleInputChange(index, "isSent", true);
  };

  const addRow = () => {
    setRows((prevRows) => {
      const nextRows = [
        ...prevRows,
        {
          "S. No.": prevRows.length + 1,
          "Product Description": null,
          "HSN code": "",
          UOM: "",
          Qty: 1,
          Rate: 0,
          Amount: 0,
          Discount: 0,
          "Taxable Value": 0,
          "CGST Rate": 0,
          "CGST Amount": 0,
          "SGST Rate": 0,
          "SGST Amount": 0,
          "IGST Rate": 0,
          "IGST Amount": 0,
          Total: 0,
          subtotal: 0,
          isSent: false,
        },
      ];
      recalculateTotals(nextRows);
      return nextRows;
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("accessToken");
      const adminId = localStorage.getItem("adminId");
      if (!token || !adminId) return;

      try {
        const productRes = await axios.get(`${path_url}/product/invoice/${adminId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });
        setData(productRes.data);
      } catch (error) {
        console.error("Error fetching invoice products:", error);
      }

      try {
        const customerRes = await axios.get(`${path_url}/customer/dashboard/${adminId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });
        if (customerRes.data?.body?.customerList) {
          setCustomerList(customerRes.data.body.customerList);
        }
      } catch (err) {
        console.error("Error fetching customers for invoice:", err);
      }
    };
    fetchData();
  }, []);

  return (
    <>
      <div>
        <div className="subcon1" style={handleclickonbutton1(hamburger)}>
          <MainSidebar hamburger={hamburger} sethamburger={sethamburger} />
        </div>
        <div className="subcon2" style={handleclickonbutton(hamburger)}>
          <UserNavbar
            hamburger={hamburger}
            sethamburger={sethamburger}
            handelRightMenuShow={handelRightMenuShow}
            handelShow={handelShow}
            isSearchShow={isSearchShow}
            handleScreenEnter={handleScreenEnter}
            handleScreenExit={handleScreenExit}
            fullScreen={fullScreen}
          />

          <div style={{ marginBottom: "15%" }}>
            <div className="content-wrapper">
              <section className="content-header">
                <div className="container-fluid">
                  <div className="row mb-2 align-items-center">
                    <div className="col-sm-6">
                      <h4>Create Invoice</h4>
                    </div>
                    <div className="col-sm-6">
                      <ul className="breadcrumb float-sm-right mb-2">
                        <li className="breadcrumb-item">
                          <Link to="/crm-dashboard">Home</Link>
                        </li>
                        <li className="breadcrumb-item">
                          <Link to="/customer-dashboard">Customers</Link>
                        </li>
                        <li className="breadcrumb-item">Create Invoice</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </section>

              <section className="content">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-12">
                      <div className="callout callout-info">
                        <h5>
                          <i className="fas fa-info"></i> Note:
                        </h5>
                        This page has been enhanced for printing. Click the print button at the
                        bottom of the invoice to test.
                      </div>

                      <div className="ci-form-card" id="to-print">
                        <div className="ci-company-bar">
                          <h3 className="ci-company-name">
                            <FaBuilding style={{ color: "#64748b" }} /> Entelipro ERP Ltd.
                          </h3>
                          <div className="ci-type-selector">
                            <label style={{ margin: 0 }}>Copy Type:</label>
                            <div style={{ width: "150px" }}>
                              <Select
                                value={invoiceType}
                                onChange={handleInvoiceTypeChange}
                                options={options}
                                styles={{
                                  control: (provided) => ({
                                    ...provided,
                                    minHeight: "32px",
                                    fontSize: "0.83rem",
                                    borderColor: "#cbd5e1",
                                  }),
                                }}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="row invoice-info">
                          <div className="col-sm-3 invoice-col">
                            <b>Details of Receiver</b>
                            <form className="form-container">
                              <label htmlFor="name">Name:</label>
                              <input
                                type="text"
                                id="name"
                                name="name"
                                placeholder="Enter your name"
                                value={senderData.name}
                                onChange={handleSenderDataChange}
                              />

                              <label htmlFor="address">Address:</label>
                              <textarea
                                rows="4"
                                cols="16"
                                id="address"
                                name="address"
                                placeholder="Enter receiver address"
                                value={senderData.address}
                                onChange={handleSenderDataChange}
                              ></textarea>

                              <label htmlFor="gstin">GSTIN:</label>
                              <input
                                type="text"
                                id="gstin"
                                name="gstin"
                                placeholder="Enter GSTIN number"
                                value={senderData.gstin}
                                onChange={handleSenderDataChange}
                              />

                              <div className="form-group">
                                <div className="form-section">
                                  <label htmlFor="state">State:</label>
                                  <input
                                    type="text"
                                    id="state"
                                    name="state"
                                    placeholder="Enter state"
                                    value={senderData.state}
                                    onChange={handleSenderDataChange}
                                  />
                                </div>

                                <div className="form-section">
                                  <label htmlFor="code">Code:</label>
                                  <input
                                    type="text"
                                    id="code"
                                    name="code"
                                    placeholder="Enter code"
                                    value={senderData.code}
                                    onChange={handleSenderDataChange}
                                  />
                                </div>
                              </div>
                            </form>
                          </div>

                          <div className="col-sm-3 invoice-col">
                            <b>Details of Consignee</b>
                            <form className="form-container">
                              <label htmlFor="name">Name:</label>
                              <input
                                type="text"
                                id="name"
                                name="name"
                                placeholder="Enter your name"
                                value={receiverData.name}
                                onChange={handleReceiverDataChange}
                              />

                              <label htmlFor="address">Address:</label>
                              <textarea
                                rows="4"
                                cols="16"
                                id="address"
                                name="address"
                                placeholder="Enter consignee address"
                                value={receiverData.address}
                                onChange={handleReceiverDataChange}
                              ></textarea>

                              <label htmlFor="gstin">GSTIN:</label>
                              <input
                                type="text"
                                id="gstin"
                                name="gstin"
                                placeholder="Enter GSTIN number"
                                value={receiverData.gstin}
                                onChange={handleReceiverDataChange}
                              />

                              <div className="form-group">
                                <div className="form-section">
                                  <label htmlFor="state">State:</label>
                                  <input
                                    type="text "
                                    id="state"
                                    name="state"
                                    placeholder="Enter state"
                                    value={receiverData.state}
                                    onChange={handleReceiverDataChange}
                                  />
                                </div>

                                <div className="form-section">
                                  <label htmlFor="code">Code:</label>
                                  <input
                                    type="text "
                                    id="code"
                                    name="code"
                                    placeholder="Enter code"
                                    value={receiverData.code}
                                    onChange={handleReceiverDataChange}
                                  />
                                </div>
                              </div>
                            </form>
                          </div>

                          <div className="col-sm-3 invoice-col">
                            <b>Invoice Details</b>
                            <form className="form-container">
                              <label htmlFor="invoiceNo">Invoice No:</label>
                              <input
                                type="text"
                                id="invoiceNo"
                                name="invoiceNo"
                                placeholder="Enter invoice number"
                                value={invoiceDetails.invoiceNo}
                                onChange={(e) =>
                                  handleInvoiceDetailsChange("invoiceNo", e.target.value)
                                }
                              />

                              <label htmlFor="invoiceDate">Invoice Date:</label>
                              <div className="invoice-datepicker hide-border">
                                <DatePicker
                                  id="invoiceDate"
                                  name="invoiceDate"
                                  selected={invoiceDetails.invoiceDate}
                                  onChange={(date) =>
                                    handleInvoiceDetailsChange("invoiceDate", date)
                                  }
                                  dateFormat="dd/MM/yyyy"
                                  className="custom-datepicker"
                                  placeholderText="Select date"
                                />
                              </div>

                              <label htmlFor="reverseCharge">Reverse Charge:</label>
                              <Select
                                id="reverseCharge"
                                name="reverseCharge"
                                options={[
                                  { value: false, label: "No" },
                                  { value: true, label: "Yes" },
                                ]}
                                value={{
                                  value: invoiceDetails.reverseCharge,
                                  label: invoiceDetails.reverseCharge ? "Yes" : "No",
                                }}
                                onChange={(selectedOption) =>
                                  handleInvoiceDetailsChange(
                                    "reverseCharge",
                                    selectedOption.value
                                  )
                                }
                              />

                              <div className="form-group">
                                <div className="form-section">
                                  <label htmlFor="state">State:</label>
                                  <input
                                    type="text"
                                    id="state"
                                    name="state"
                                    placeholder="Enter state"
                                    value={invoiceDetails.state}
                                    onChange={(e) =>
                                      handleInvoiceDetailsChange("state", e.target.value)
                                    }
                                  />
                                </div>

                                <div className="form-section">
                                  <label htmlFor="code">Code:</label>
                                  <input
                                    type="text"
                                    id="code"
                                    name="code"
                                    placeholder="Enter code"
                                    value={invoiceDetails.code}
                                    onChange={(e) =>
                                      handleInvoiceDetailsChange("code", e.target.value)
                                    }
                                  />
                                </div>
                              </div>
                            </form>
                          </div>

                          <div className="col-sm-3 invoice-col">
                            <b>Transport Details</b>
                            <form className="form-container">
                              <label htmlFor="transportMode">Transport Mode:</label>
                              <input
                                type="text"
                                id="transportMode"
                                name="transportMode"
                                placeholder="Enter transport mode"
                                value={transportData.transportMode}
                                onChange={(e) =>
                                  handleTransportDataChange("transportMode", e.target.value)
                                }
                              />

                              <label htmlFor="vehicleNumber">Vehicle Number:</label>
                              <input
                                type="text"
                                id="vehicleNumber"
                                name="vehicleNumber"
                                placeholder="Enter vehicle number"
                                value={transportData.vehicleNumber}
                                onChange={(e) =>
                                  handleTransportDataChange("vehicleNumber", e.target.value)
                                }
                              />

                              <label htmlFor="date">Date:</label>
                              <div className="invoice-datepicker hide-border">
                                <DatePicker
                                  id="date"
                                  name="date"
                                  selected={transportData.date}
                                  onChange={(date) =>
                                    handleTransportDataChange("date", date)
                                  }
                                  dateFormat="dd/MM/yyyy"
                                  className="custom-datepicker"
                                  placeholderText="Select date"
                                />
                              </div>

                              <label htmlFor="place">Place:</label>
                              <input
                                type="text"
                                id="place"
                                name="place"
                                placeholder="Enter place of supply"
                                value={transportData.place}
                                onChange={(e) =>
                                  handleTransportDataChange("place", e.target.value)
                                }
                              />
                            </form>
                          </div>
                        </div>

                        <div className="horizontal-fix">
                          <div>
                            <table>
                              <thead>
                                <tr className="table-row">
                                  {columnNames.slice(0, 9).map((value) => (
                                    <th key={value} rowSpan={2}>
                                      {value}
                                    </th>
                                  ))}
                                  <th colSpan={2}>CGST</th>
                                  <th colSpan={2}>SGST</th>
                                  <th colSpan={2}>IGST</th>
                                  {columnNames.slice(15).map((value) => (
                                    <th key={value} rowSpan={2}>
                                      {value}
                                    </th>
                                  ))}
                                </tr>
                                <tr className="table-row">
                                  {columnNames.slice(9, 11).map((value) => (
                                    <th key={value}>{value}</th>
                                  ))}
                                  {columnNames.slice(11, 13).map((value) => (
                                    <th key={value}>{value}</th>
                                  ))}
                                  {columnNames.slice(13, 15).map((value) => (
                                    <th key={value}>{value}</th>
                                  ))}
                                </tr>
                              </thead>
                              <tbody>
                                {rows.map((row, index) => (
                                  <tr className="table-row" key={index}>
                                    <td className="input-cell">
                                      <input
                                        type="number"
                                        value={row["S. No."]}
                                        onChange={(e) =>
                                          handleInputChange(index, "S. No.", e.target.value)
                                        }
                                      />
                                    </td>
                                    <td className="input-cell" style={{ minWidth: "180px" }}>
                                      <CreatableSelect
                                        value={row["Product Description"]}
                                        onChange={(value) =>
                                          handleInputChange(index, "Product Description", value)
                                        }
                                        options={
                                          data?.body?.productList && data.body.productList.length > 0
                                            ? data.body.productList.map((product) => ({
                                              value: product.id,
                                              label: product.productname,
                                              productDetails: product,
                                            }))
                                            : DEFAULT_PRODUCT_OPTIONS.map((sample) => ({
                                              value: sample.value,
                                              label: sample.label,
                                            }))
                                        }
                                        placeholder="Select / Type Product"
                                        isSearchable
                                        isClearable
                                        formatCreateLabel={(inputValue) =>
                                          `Use "${inputValue}"`
                                        }
                                        className="custom-select-container"
                                        classNamePrefix="custom-select"
                                      />
                                    </td>
                                    <td className="input-cell">
                                      <input
                                        type="text"
                                        value={row["HSN code"] || ""}
                                        onChange={(e) =>
                                          handleInputChange(index, "HSN code", e.target.value)
                                        }
                                        style={{ minWidth: "80px" }}
                                      />
                                    </td>
                                    <td className="input-cell">
                                      <input
                                        type="text"
                                        value={row.UOM || ""}
                                        onChange={(e) =>
                                          handleInputChange(index, "UOM", e.target.value)
                                        }
                                        style={{ minWidth: "50px" }}
                                      />
                                    </td>
                                    <td className="input-cell">
                                      <input
                                        type="number"
                                        value={row.Qty}
                                        onChange={(e) =>
                                          handleInputChange(index, "Qty", e.target.value)
                                        }
                                      />
                                    </td>
                                    <td className="input-cell">
                                      <input
                                        type="number"
                                        step="any"
                                        value={row.Rate}
                                        onChange={(e) =>
                                          handleInputChange(index, "Rate", e.target.value)
                                        }
                                        style={{ minWidth: "60px" }}
                                      />
                                    </td>
                                    <td className="input-cell">
                                      <input
                                        type="text"
                                        value={row.Amount ?? 0}
                                        readOnly
                                      />
                                    </td>
                                    <td className="input-cell">
                                      <input
                                        type="number"
                                        step="any"
                                        value={row.Discount ?? 0}
                                        onChange={(e) =>
                                          handleInputChange(index, "Discount", e.target.value)
                                        }
                                      />
                                    </td>
                                    <td className="input-cell">
                                      <input
                                        type="number"
                                        step="any"
                                        value={row["Taxable Value"] ?? 0}
                                        onChange={(e) =>
                                          handleInputChange(
                                            index,
                                            "Taxable Value",
                                            e.target.value
                                          )
                                        }
                                      />
                                    </td>
                                    <td className="input-cell">
                                      <input
                                        type="number"
                                        step="any"
                                        value={row["CGST Rate"] ?? 0}
                                        onChange={(e) =>
                                          handleInputChange(index, "CGST Rate", e.target.value)
                                        }
                                      />
                                    </td>
                                    <td className="input-cell">
                                      <input
                                        type="number"
                                        step="any"
                                        value={row["CGST Amount"] ?? 0}
                                        onChange={(e) =>
                                          handleInputChange(index, "CGST Amount", e.target.value)
                                        }
                                      />
                                    </td>
                                    <td className="input-cell">
                                      <input
                                        type="number"
                                        step="any"
                                        value={row["SGST Rate"] ?? 0}
                                        onChange={(e) =>
                                          handleInputChange(index, "SGST Rate", e.target.value)
                                        }
                                      />
                                    </td>
                                    <td className="input-cell">
                                      <input
                                        type="number"
                                        step="any"
                                        value={row["SGST Amount"] ?? 0}
                                        onChange={(e) =>
                                          handleInputChange(index, "SGST Amount", e.target.value)
                                        }
                                      />
                                    </td>
                                    <td className="input-cell">
                                      <input
                                        type="number"
                                        step="any"
                                        value={row["IGST Rate"] ?? 0}
                                        onChange={(e) =>
                                          handleInputChange(index, "IGST Rate", e.target.value)
                                        }
                                      />
                                    </td>
                                    <td className="input-cell">
                                      <input
                                        type="number"
                                        step="any"
                                        value={row["IGST Amount"] ?? 0}
                                        onChange={(e) =>
                                          handleInputChange(index, "IGST Amount", e.target.value)
                                        }
                                      />
                                    </td>
                                    <td className="input-cell">
                                      <input
                                        type="text"
                                        value={row.Total ?? (row.subtotal ?? 0)}
                                        readOnly
                                      />
                                    </td>
                                    <td>
                                      <button
                                        className="upload-button"
                                        onClick={() => handleSendRow(index)}
                                      >
                                        {row.isSent ? (
                                          <i className="fa fa-check" aria-hidden="true"></i>
                                        ) : (
                                          <i className="fa fa-cloud-upload" aria-hidden="true"></i>
                                        )}
                                      </button>
                                    </td>
                                    <td>
                                      <button
                                        className="delete-button"
                                        onClick={() => handleDeleteRow(index)}
                                      >
                                        <i className="fa fa-trash" aria-hidden="true"></i>
                                      </button>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                            <button className="addButton" onClick={addRow}>
                              Add Product
                            </button>
                            <button
                              className="addButton"
                              onClick={handleCalculation}
                              style={{ marginLeft: "10px" }}
                            >
                              Calculate Tax
                            </button>
                          </div>
                        </div>

                        <div className="row payment-details">
                          <div className="col-lg-6">
                            <div className="to-words">
                              <h3>Total Invoice Amount in Words</h3>
                              <p>Rs. {amountInWords} RUPEES ONLY/-</p>
                            </div>
                            <div className="bank-details-form">
                              <h2>Bank Details</h2>
                              <div className="floating-label-group">
                                <input
                                  type="text"
                                  id="bankName"
                                  name="bankName"
                                  value={bankDetails.bankName}
                                  onChange={handleBankDetailsChange}
                                  className="form-control"
                                  placeholder=" "
                                  required
                                />
                                <label className="floating-label">Bank Name</label>
                              </div>
                              <div className="floating-label-group">
                                <input
                                  type="text"
                                  id="bankAccNo"
                                  name="bankAccNo"
                                  value={bankDetails.bankAccNo}
                                  onChange={handleBankDetailsChange}
                                  className="form-control"
                                  placeholder=" "
                                  required
                                />
                                <label className="floating-label">
                                  Bank Account Number
                                </label>
                              </div>
                              <div className="floating-label-group">
                                <input
                                  type="text"
                                  id="bankIFSC"
                                  name="bankIFSC"
                                  value={bankDetails.bankIFSC}
                                  onChange={handleBankDetailsChange}
                                  className="form-control"
                                  placeholder=" "
                                  required
                                />
                                <label className="floating-label">Bank IFSC</label>
                              </div>
                              <div className="floating-label-group">
                                <textarea
                                  id="termsAndConditions"
                                  name="termsAndConditions"
                                  value={bankDetails.termsAndConditions}
                                  onChange={handleBankDetailsChange}
                                  className="form-control"
                                  placeholder=" "
                                  required
                                />
                                <label className="floating-label">
                                  Terms and Conditions
                                </label>
                              </div>
                            </div>
                            <p className="lead mb-2">
                              Payment Methods:
                              <img src={visaImage} alt="Visa" />
                              <img src={mastercardImage} alt="Mastercard" />
                              <img src={americanexpressImage} alt="American Express" />
                              <img src={paypalImage} alt="Paypal" />
                            </p>
                          </div>
                          <div className="col-lg-6">
                            <div className="table-responsive">
                              <table className="table">
                                <tbody>
                                  <tr>
                                    <th style={{ width: "50%" }}>
                                      Total Amount before Tax:
                                    </th>
                                    <td>Rs. {totalSubtotal || 0}</td>
                                  </tr>
                                  <tr>
                                    <th>Total CGST</th>
                                    <td>Rs. {tax.cgstTax || 0}</td>
                                  </tr>
                                  <tr>
                                    <th>Total SGST</th>
                                    <td>Rs. {tax.sgstTax || 0}</td>
                                  </tr>
                                  <tr>
                                    <th>Total IGST</th>
                                    <td>Rs. {tax.igstTax || 0}</td>
                                  </tr>
                                  <tr>
                                    <th>Total Tax Amount</th>
                                    <td>Rs. {totalTax || 0}</td>
                                  </tr>
                                  <tr>
                                    <th>Freight</th>
                                    <td>
                                      Rs.{" "}
                                      <input
                                        type="number"
                                        step="any"
                                        value={freight}
                                        onChange={handleFreightChange}
                                        style={{
                                          background: "transparent",
                                          border: "1px solid #ccc",
                                          borderRadius: "4px",
                                          padding: "2px 6px",
                                          width: "90px",
                                        }}
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <th>Insurance</th>
                                    <td>
                                      Rs.{" "}
                                      <input
                                        type="number"
                                        step="any"
                                        value={insurance}
                                        onChange={handleInsuranceChange}
                                        style={{
                                          background: "transparent",
                                          border: "1px solid #ccc",
                                          borderRadius: "4px",
                                          padding: "2px 6px",
                                          width: "90px",
                                        }}
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <th>Packing and Forwarding Charges</th>
                                    <td>
                                      Rs.{" "}
                                      <input
                                        type="number"
                                        step="any"
                                        value={packingCharges}
                                        onChange={handlePackingChargesChange}
                                        style={{
                                          background: "transparent",
                                          border: "1px solid #ccc",
                                          borderRadius: "4px",
                                          padding: "2px 6px",
                                          width: "90px",
                                        }}
                                      />
                                    </td>
                                  </tr>
                                  <tr
                                    style={{
                                      fontSize: "1.5em",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    <th>GrandTotal</th>
                                    <td>Rs. {totalGrandtotal || 0}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>

                        <div className="row no-print">
                          <div className="col-12">
                            <a
                              href="#"
                              rel="noopener"
                              target="_blank"
                              onClick={(e) => {
                                e.preventDefault();
                                handlePrint();
                              }}
                            >
                              <i className="fas fa-print"></i> Print
                            </a>
                            <div className="d-block d-md-flex justify-content-end">
                              <button
                                type="button"
                                className="btn btn-success col-12 col-md-auto mb-2 mb-md-0"
                                onClick={handleSaveInvoice}
                                disabled={isSaving}
                              >
                                <i
                                  className={
                                    isSaving
                                      ? "fas fa-spinner fa-spin"
                                      : "far fa-credit-card"
                                  }
                                ></i>{" "}
                                {isSaving ? "Saving..." : "Submit Payment"}
                              </button>
                              <button
                                type="button"
                                className="btn btn-primary col-12 col-md-auto mb-2 mb-md-0 ml-md-2"
                                onClick={handleGeneratePDF}
                              >
                                <i className="fas fa-download"></i> Generate PDF
                              </button>
                              <button
                                type="button"
                                className="btn btn-info col-12 col-md-auto ml-md-2"
                                onClick={handleESignModal}
                              >
                                <i className="fas fa-pencil"></i> E-Sign
                              </button>
                              <ESign show={lgShow} handleClose={handleCloseModal} />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
            <div style={{ height: "140px" }} />
          </div>

          <UserFooter />
          <ToastContainer
            position="top-right"
            autoClose={4000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
          />
        </div>
      </div>
    </>
  );
};

export default CreateInvoice;